import DesktopPickupDateTime from './commons/PickupDateTime/Desktop';
import DesktopCruiseSelector from './commons/CruiseSelector/Desktop';
import DesktopShipSelector from './commons/ShipSelector';
import builder from './builder.js';

export default builder({
  CruiseComponent: DesktopCruiseSelector,
  ShipSelector: DesktopShipSelector,
  DateTimeComponent: DesktopPickupDateTime
});
